import * as React from "react";
import Modal from "../../ui/modal/Modal";
import TextArea from "../../../hiberUiKit/src/atoms/TextArea/TextArea";
import FormButtonsView from "../../ui/form/FormButtonsView";
import Input from "../../../hiberUiKit/src/atoms/Input/Input";
import {none, option} from "ts-option";
import FormGroup from "../../../hiberUiKit/src/molecules/FormGroup/FormGroup";
import Amount from "../../../model/common/Amount";
import QuoteItem from "../../../model/quote/QuoteItem";
import CurrencyInput from "../../../hiberUiKit/src/atoms/Input/CurrencyInput";
import ButtonTertiary from "../../../hiberUiKit/src/atoms/Buttons/ButtonTertiary";
import ButtonPrimary from "../../../hiberUiKit/src/atoms/Buttons/ButtonPrimary";
import Checkbox from "../../../hiberUiKit/src/atoms/Checkbox/Checkbox";
import NumberUtils from "../../../utils/NumberUtils";

interface IComponentProps {
	/**
	 * Close modal callback.
	 */
	onClose: () => void;
	/**
	 * On add function
	 * @param item
	 */
	onAdd: (item: QuoteItem) => void;
	/**
	 * VAT registered
	 */
	vatRegistered: boolean;
	/**
	 * Vat
	 */
	vat: number
	/**
	 * Custom parts markup
	 */
	bespokeItemMarkup: number
}

interface IState {
	/**
	 * Item name
	 */
	name: string;
	/**
	 * Item description
	 */
	description: string;
	/**
	 * Item price
	 */
	price: string
	/**
	 * Item discount
	 */
	discount: boolean;
	/**
	 * Item self-sourced
	 */
	selfSourced: boolean
}

type Props = IComponentProps

export default class AddBespokeQuoteItemModal extends React.PureComponent<Props, IState> {

	constructor(props: Props) {
		super(props);
		this.state = {
			name: "",
			description: "",
			price: "",
			discount: false,
			selfSourced: false
		};

		this.onAddEvent = this.onAddEvent.bind(this);
	}

	render() {
		return (
			<Modal onCloseClicked={this.props.onClose}
				   title={"Add bespoke item"}>
				<FormGroup label={"Item name"}>
					<Input type={"text"}
						   value={this.state.name}
						   placeholder={"Type item name"}
						   focus
						   onChange={(e) => {this.setState({name: e.target.value})}}/>
				</FormGroup>
				<FormGroup label={`Price (€) (${this.props.vatRegistered ? "excluding" : "including"} VAT)`}>
					<CurrencyInput onChange={(e) => {this.setState({price: e.getOrElse("")})}}
								   value={option(this.state.price)}
								   placeholder={""}/>
				</FormGroup>
				<FormGroup label={"Item description"}>
					<TextArea onChange={(e) => {this.setState({description: e.target.value})}}
							  hasBorder={true}
							  value={this.state.description}
							  placeholder={"Quote item description"}
							  rows={5}/>
				</FormGroup>
				<FormGroup>
					<Checkbox label={"Make this item a discount"}
							  onChange={(e) => {this.setState({discount: e})}}
							  checked={this.state.discount}/>
				</FormGroup>
				<FormGroup>
					<Checkbox label={"Self sourced"}
							  onChange={(e) => {this.setState({selfSourced: e})}}
							  checked={this.state.selfSourced}/>
				</FormGroup>
				<FormButtonsView align={"right"}>
					<div style={{paddingTop: "20px"}}>
						<div className="pull-left">
							<ButtonTertiary label="Cancel" onClick={this.props.onClose}/>
						</div>
						<ButtonPrimary label={"Add item"} onClick={this.onAddEvent} disabled={this.shouldButtonBeDisabled()}/>
					</div>
				</FormButtonsView>
			</Modal>
		)
	}

	onAddEvent() {
		const description = this.state.description ? option(this.state.description) : none;
		const price = NumberUtils.multiplyAndRound(Number(this.state.price), 100 * (this.state.discount ? -1 : 1));
		this.props.onAdd(QuoteItem.createBespokeItem(this.state.name, "", "", new Amount(price),
			description, this.props.vatRegistered, this.props.vat, this.state.selfSourced ? 0 : this.props.bespokeItemMarkup,
			this.state.selfSourced));
	}

	shouldButtonBeDisabled() {
		return this.state.name.trim() == "" || this.state.price.trim() == "";
	}
}
